<div class="field-wrapper" *ngIf="formattedPoint">
  <span class="value-wrapper" [matTooltip]="formattedPoint">{{ formattedPoint }}</span>
  <button mat-icon-button
      class="copy-button"
      [cdkCopyToClipboard]="formattedPoint"
      matTooltip="Copy to clipboard"
      (cdkCopyToClipboardCopied)="onCopyToClipboard.emit('Field value was copied to clipboard.')"
      (click)="$event.stopPropagation()">
    <mat-icon>content_copy</mat-icon>
  </button>
</div>
